import {initFlowbite} from "flowbite";

class FlowbiteDatepickerI18n {
    static languages = {
        hu: {
            days: ["vasárnap", "hétfő", "kedd", "szerda", "csütörtök", "péntek", "szombat"],
            daysShort: ["vas", "hét", "ked", "sze", "csü", "pén", "szo"],
            daysMin: ["V", "H", "K", "Sze", "Cs", "P", "Szo"],
            months: ["január", "február", "március", "április", "május", "június", "július", "augusztus", "szeptember", "október", "november", "december"],
            monthsShort: ["jan", "feb", "már", "ápr", "máj", "jún", "júl", "aug", "sze", "okt", "nov", "dec"],
            today: "ma",
            weekStart: 1,
            clear: "töröl",
            titleFormat: "y. MM",
            format: "yyyy.mm.dd"
        }
    };

    static assignLanguage = () => {
        let flowbitePickers = Object.values(FlowbiteInstances.getInstances('Datepicker'))
            .map((instance) => {
                return instance.getDatepickerInstance();
            });

        for (const flowbitePicker of flowbitePickers) {
            for (const picker of flowbitePicker.datepickers || [flowbitePicker]) {
                const language = picker.element?.attributes['datepicker-language']?.value;
                if (language && language in FlowbiteDatepickerI18n.languages) {
                    Object.assign(picker.constructor.locales, FlowbiteDatepickerI18n.languages);
                    picker.setOptions({language: language});
                }
            }
        }
    }

    static init = () => {
        window.addEventListener('load', () => {
            setTimeout(() => {
                FlowbiteDatepickerI18n.assignLanguage();
            });
        });
    }
}

initFlowbite();
FlowbiteDatepickerI18n.init();
